/*
  References

  "hero": {
    "width": 1360,
    "height": 765
  },
  "mainscreen": {
    "width": 900,
    "height": 510
  },
  "cover": {
    "width": 445,
    "height": 250
  },
  "xcover": {
    "width": 300,
    "height": 170
  }
*/

export const getThumbnail = (video, size = 'cover') => {
  if (!video || !video.media) return
  const coverImg = video.media[0].sizes[size]
  const coverImgOrder1 = video.media.find(item => item.order === 1)?.sizes[size]
  const coverImgOrder0 = video.media.find(item => item.order === 0)?.sizes[size]

  if (coverImgOrder1) return coverImgOrder1
  if (coverImgOrder0) return coverImgOrder0
  return coverImg
}